<app-breadcrumb [title]="'Soporte Digitales'" [items]="['Personas']" [active_item]="'Digitales'"></app-breadcrumb>

<div class="container-fluid py-4">
  <div class="row gy-4">
    <div *ngFor="let archivo of archivos" class="col-sm-12 col-md-4">
      <div class="card shadow-sm rounded h-100 d-flex flex-column">
        <div class="card-header bg-primary text-white text-center fw-bold">
          {{ archivo.nombre }}
        </div>

        <div class="card-body d-flex flex-column align-items-center justify-content-center">
          <input 
            type="file" 
            class="d-none" 
            (change)="onFileChange($event, archivo.id)" 
            [id]="'fileInput' + archivo.id" 
            [accept]="archivo.acceptedFormats" 
            aria-label="Subir archivo {{ archivo.nombre }}">
            
          <label 
            [for]="'fileInput' + archivo.id" 
            class="dropzone-label w-100 d-flex flex-column align-items-center justify-content-center py-4 border border-primary rounded cursor-pointer"
            [class.has-file]="archivo.file"
            tabindex="0"
            (keydown.enter)="document.getElementById('fileInput' + archivo.id)?.click()"
            (keydown.space)="document.getElementById('fileInput' + archivo.id)?.click()"
             (dragover)="onDragOver($event)"
             (dragleave)="onDragLeave($event)"  (drop)="onDrop($event, archivo.id)"
             
            >
            
            <ng-container *ngIf="archivo.file; else noFile">
              <img 
                *ngIf="isImage(archivo.file.file)" 
                [src]="archivo.file.preview" 
                class="preview-img mb-2 rounded shadow-sm" 
                
                alt="Preview de {{ archivo.nombre }}"
                role="button"
                title="Click para ampliar">
              
              <div 
                *ngIf="!isImage(archivo.file.file)" 
                class="pdf-preview-icon d-flex flex-column align-items-center text-danger mb-2"
                role="img"
                aria-label="Archivo PDF">
                <i class="fa fa-pdf"></i>
                <small>Archivo PDF</small>
              </div>

              <small class="text-muted text-truncate" [title]="archivo.file.file.name">{{ archivo.file.file.name }}</small>
            </ng-container>

            <ng-template #noFile>
              <i class="bi bi-upload fs-1 text-primary mb-2"></i>
              <p class="mb-0 fw-semibold text-primary text-center">Haz click o arrastra para cargar</p>
            </ng-template>
          </label>
        </div>

        <div *ngIf="archivo.estado === 'subiendo'" class="progress my-2 mx-3" role="progressbar" aria-valuemin="0" aria-valuemax="100" [attr.aria-valuenow]="archivo.progreso">
          <div class="progress-bar progress-bar-striped progress-bar-animated" [style.width.%]="archivo.progreso">
            {{ archivo.progreso }}%
          </div>
        </div>

        <div *ngIf="archivo.estado === 'exito'" class="alert alert-success mx-3 my-2 text-center py-1" role="alert">
          {{ archivo.mensaje }}
        </div>

        <div *ngIf="archivo.estado === 'error'" class="alert alert-danger mx-3 my-2 text-center py-1" role="alert">
          {{ archivo.mensaje }}
        </div>

        <div class="card-footer d-flex justify-content-center gap-2">
            
          <button 
            *ngIf="archivo.file" 
            class="btn btn-success flex-grow-1" 
            (click)="subirArchivo(archivo.id,'empresas', archivo.prefijo)">
            Enviar Archivo
          </button>
          <button 
            *ngIf="archivo.file" 
            class="btn btn-danger flex-grow-1" 
            (click)="removeFile(archivo.id)">
            Eliminar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
